import type { TargetPriority } from '../entities/Tower'
import type { TowerKind } from './towers'

export type LoadoutId = 'BALANCED_GRID' | 'RUSH_INTERCEPT' | 'BOSS_HUNTER'
export type TowerSynergyId = 'VALIDATOR_RELAY' | 'SETTLEMENT_LINK' | 'HASHFLOW_CHANNEL'

export interface LoadoutDefinition {
  readonly id: LoadoutId
  readonly name: string
  readonly codename: string
  readonly description: string
  readonly color: string
  readonly priorities: Record<TowerKind, TargetPriority>
}

export interface TowerSynergyDefinition {
  readonly id: TowerSynergyId
  readonly name: string
  readonly pair: readonly [TowerKind, TowerKind]
  readonly description: string
  readonly maxDistance: number
  readonly color: number
  readonly cssColor: string
  readonly damage: number
  readonly attackSpeed: number
  readonly range: number
}

export const LOADOUTS: Record<LoadoutId, LoadoutDefinition> = {
  BALANCED_GRID: { id: 'BALANCED_GRID', name: 'BALANCED GRID', codename: 'STANDARD', description: 'SOL and ETH hold the front while BTC hunts the strongest hostile.', color: '#35d8ea', priorities: { SOL: 'FIRST', ETH: 'FIRST', BTC: 'STRONGEST' } },
  RUSH_INTERCEPT: { id: 'RUSH_INTERCEPT', name: 'RUSH INTERCEPT', codename: 'LEAK CONTROL', description: 'Fast towers watch the rear line while BTC removes weakened escapees.', color: '#37e2ae', priorities: { SOL: 'LAST', ETH: 'FIRST', BTC: 'WEAKEST' } },
  BOSS_HUNTER: { id: 'BOSS_HUNTER', name: 'BOSS HUNTER', codename: 'HEAVY LOCK', description: 'Every module prioritizes high-integrity targets and armored bosses.', color: '#f3a446', priorities: { SOL: 'STRONGEST', ETH: 'STRONGEST', BTC: 'STRONGEST' } },
}

export const LOADOUT_IDS = Object.keys(LOADOUTS) as LoadoutId[]

export const TOWER_SYNERGIES: Record<TowerSynergyId, TowerSynergyDefinition> = {
  VALIDATOR_RELAY: { id: 'VALIDATOR_RELAY', name: 'VALIDATOR RELAY', pair: ['SOL', 'ETH'], description: '+12% attack speed', maxDistance: 225, color: 0x45e8d0, cssColor: '#45e8d0', damage: 1, attackSpeed: 1.12, range: 1 },
  SETTLEMENT_LINK: { id: 'SETTLEMENT_LINK', name: 'SETTLEMENT LINK', pair: ['ETH', 'BTC'], description: '+15% damage', maxDistance: 240, color: 0xb88aff, cssColor: '#b88aff', damage: 1.15, attackSpeed: 1, range: 1 },
  HASHFLOW_CHANNEL: { id: 'HASHFLOW_CHANNEL', name: 'HASHFLOW CHANNEL', pair: ['SOL', 'BTC'], description: '+12% range', maxDistance: 230, color: 0xffb142, cssColor: '#ffb142', damage: 1, attackSpeed: 1, range: 1.12 },
}

export const TOWER_SYNERGY_IDS = Object.keys(TOWER_SYNERGIES) as TowerSynergyId[]

export function getTowerSynergy(first: TowerKind, second: TowerKind): TowerSynergyDefinition | null {
  return TOWER_SYNERGY_IDS.map((id) => TOWER_SYNERGIES[id]).find(({ pair }) => pair.includes(first) && pair.includes(second) && first !== second) ?? null
}
